import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';
import {getsurvey} from '@/functions.js';

import Contacts from './modules/contacts';
import Shares from './modules/shares';
import Users from './modules/users';
import Groups from './modules/groups';
import Surveys from './modules/surveys';
import Projects from './modules/projects';

Vue.use(Vuex);
Vue.use(require('vue-cookies'))

window.callCloudFunction=function(theUrl,vue) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
            alert(xmlHttp.responseText);
        }
    }
    xmlHttp.open("GET", theUrl, true); // true for asynchronous 
    xmlHttp.send(null);
}

export default new Vuex.Store({
    modules: {
        Contacts,
        Shares,
        Users,
        Groups,
        Surveys,
        Projects
    },
    state: {
        mytags: [],
        mediatags: [],
        pagememory:[],
        paymentconfirmed:false,
        currentmonth:"",
        useraccount:null,
        mapclickcount: 0,
        mapcentre: L.latLng(47.413220, -1.219482),
        mapmarkers: [L.latLng(47.412, -1.218), L.latLng(47.417220, -1.219482), L.latLng(47.414, -1.22)],
        mapmarkerclicked:-1,
        greenalertcount: 0,
        amberalertcount: 0,
        redalertcount: 0,
        loginID: "",
        udata:null,
        tagletters:"",
        addingcontact: null,
        undermanagement: false,
        alertlevel:"#00FF00",
        navdrawerheight:300,
        yaw: 0,
        pitch: 0,
        mediaID: "",
        navpage: null,
        screenmode: "single",
        clickmode: 'normal',
        mediacount: 0,
        surveytagcount: 0,
        currentsurveytag: 0,
        iframewindow: null,
        imageloaded: false,
        mapvisible: false,
        mapbutton: false,
        addtagvisible: false,
        addtagbutton: false,
        selectedcontact: null,
        selectedgroup: null,
        selectedshare: null,
        imagetransform: {scale:1, x:0, y:0},
        currentproject: { name: '', id: 0 },
        deletesurveys: true,
        onlymyshares: false,
        exploresurvey: null,
        alerts: [],
        projects: [],
        contacts: [],
        groups: [],
        surveys: [],
        shares: [],
        databaseid:"",
        dialogdata: {contact:'', group:''},
        chipcount: 0,
        updatecount: 0,
        sharepopup: null,
        sharepopupdata: null,
        user: null,
        currentuser: null,
        currentmediatag:null,
        selectedshare:null,
        isAuthenticated: "unchecked",
        initialChecked: false,
        mode:'',
        heading: "",
        surveymodified: 0,
    },
    mutations: {
    },
    actions: {
        //------------------------------- survey data 
        listenForSurveyData(state, commit) {
            var dbid = commit.dbid;
            var uid = commit.uid;
            state.rootState.mediacount = 0;
            state.rootState.imageloaded = false;
            var mediaref = 'databases/' + dbid + '/users/' + uid + '/survey-data/' + state.rootState.exploresurvey.ID + '/media';
            firebase.database().ref(mediaref).on('child_added', snapshot => {
                var media = snapshot.val();
                media.ID = snapshot.key;
                state.commit('addMedia', media);
            });
            firebase.database().ref(mediaref).on('child_removed', snapshot => {
                state.commit('cutMedia', snapshot.key);
            });
            firebase.database().ref(mediaref).on('child_changed', snapshot => {
                var media = snapshot.val();
                media.ID = snapshot.key;
                state.commit('changedMedia', media);
            });   
            state.rootState.surveytagcount = 0;
            state.rootState.currentmediatag = null;
            var tagsref = 'databases/' + dbid + '/users/' + uid + '/survey-data/' + state.rootState.exploresurvey.ID + '/tags';
            firebase.database().ref(tagsref).on('child_added', snapshot => {
                var tag = snapshot.val();
                tag.ID = snapshot.key;
                state.commit('addSurveyTag', tag);
            });
            firebase.database().ref(tagsref).on('child_removed', snapshot => {
                state.commit('cutSurveyTag', snapshot.key);
            });
            firebase.database().ref(tagsref).on('child_changed', snapshot => {
                var tag = snapshot.val();
                tag.ID = snapshot.key;
                state.commit('changedSurveyTag', tag);
            });
        },
        //------------------------------- tag data 
        listenForTags(state, commit) {
            state.rootState.surveytagcount = 0;
            state.rootState.currentmediatag = null;       
            var tagsref = 'databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/tags';
            firebase.database().ref(tagsref).on('child_added', snapshot => {
                var tag = snapshot.val();
                tag.ID = snapshot.key;
                state.commit('addTag', tag);
            });
            firebase.database().ref(tagsref).on('child_removed', snapshot => {
                state.commit('cutTag', snapshot.key);
            });
            firebase.database().ref(tagsref).on('child_changed', snapshot => {
                var tag = snapshot.val();
                tag.ID = snapshot.key;
                state.commit('changedTag', tag);
            });
        },
        //------------------------------- user  
        listenForUser({ state, commit }, {force}){
            if (!state.user) return;  
            if (state.loginID === state.user.uid) return;
            state.loginID = state.user.uid;
            firebase.database().ref('usercore/' + state.user.uid).on('value', snapshot => {
                //alert("got usercore");
                var usercore = snapshot.val();
                usercore.ID = snapshot.key;
                commit('changedUserCore', usercore);
            });  
            firebase.database().ref('useraccounts/' + state.user.uid).on('value', snapshot => {
                //alert("got useraccounts");
                var useraccount = snapshot.val();
                useraccount.ID = snapshot.key;
                commit('changedUserAccount', useraccount);
            }); 
        },
        //------------------------------- contacts  
        listenForContacts({ state, commit }, { force }) {       
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mycontacts').on('child_added', snapshot => {
                var contact = snapshot.val();
                contact.ID = snapshot.key;
                commit('addContact', contact);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mycontacts').on('child_removed', snapshot => {
                commit('cutContact', snapshot.key);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mycontacts').on('child_changed', snapshot => {
                var contact = snapshot.val();
                contact.ID = snapshot.key;
                commit('changedContact', contact);
            });  
        },
        //------------------------------- groups  
        listenForGroups({ state, commit }, { force }) {
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mygroups').on('child_added', snapshot => {
                var group = snapshot.val();
                group.ID = snapshot.key;
                commit('addGroup', group);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mygroups').on('child_removed', snapshot => {
                commit('cutGroup', snapshot.key);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mygroups').on('child_changed', snapshot => {
                var group = snapshot.val();
                group.ID = snapshot.key;
                commit('changedGroup', group);
            });
        },
        //------------------------------- surveys  
        listenForSurveys({ state, commit }, { force }) {
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mysurveys').on('child_added', snapshot => {
                var survey = snapshot.val();
                survey.ID = snapshot.key;
                commit('addSurvey', survey);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mysurveys').on('child_removed', snapshot => {
                commit('cutSurvey', snapshot.key);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/mysurveys').on('child_changed', snapshot => {
                var survey = snapshot.val();
                survey.ID = snapshot.key;
                commit('changedSurvey', survey);
            });
        },
        //------------------------------- shares  
        listenForShares({ state, commit }, { force }) {
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/myshares').on('child_added', snapshot => {
                var share = snapshot.val();
                share.ID = snapshot.key;
                commit('addShare', share);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/myshares').on('child_removed', snapshot => {
                commit('cutShare', snapshot.key);
            });
            firebase.database().ref('databases/' + state.databaseid + '/users/' + state.user.uid + '/mydata/myshares').on('child_changed', snapshot => {
                var share = snapshot.val();
                share.ID = snapshot.key;
                commit('changedShare', share);
            });
        },   
    },
    getters: {
        isAuthenticated(state) {
            if (state.user !== null && state.user !== undefined)
                return "true";
            return state.isAuthenticated;
        },
        mode(state) {
            return state.mode
        }
    }
});
